import { NotFound } from './theme/NotFound';
import { useParams } from 'react-router-dom';
import { DOCDocumentType } from './DocumentManagement/Parameters/DOCDocumentType/DOCDocumentType';
import { DOCRepository } from './DocumentManagement/Parameters/DOCRepository/DOCRepository';
import { DOCTrdDocument } from './DocumentManagement/Parameters/DOCTrdDocument/DOCTrdDocument';
import { DOCMetadataDefinition } from './DocumentManagement/Parameters/DOCMetadataDefinition/DOCMetadataDefinition';
import { DOCFolder } from './DocumentManagement/Parameters/DOCFolder/DOCFolder';
import { DocumentFileManager } from './DocumentManagement/Management/DocumentFileManager/DocumentFileManager';

export const RouterDocumentManager = (props: any) => {

    const { module, view }: any = useParams();

    const renderSwitch = (url: string) => {

        switch (url) {

            case 'gestor-documental':
                return <DocumentFileManager />;
            case 'repositorios-documentales':
                return <DOCRepository />;
            case 'directorios-documentales':
                return <DOCFolder />;
            case 'tipos-documentales':
                return <DOCDocumentType />;
            case 'documentos-tipo-trd':
                return <DOCTrdDocument />;
            case 'metadata-tipo-documental':
                return <DOCMetadataDefinition />;

            default:
                return <NotFound />;
        }
    }

    return (
        <div className=''>
            {renderSwitch(view)}
        </div>
    );
}
